var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { attrs: { name: "danger-zone" } },
    [
      _c("div", { staticClass: "danger-box round-borders q-pa-md" }, [
        _c("div", { staticClass: "row items-center gutter-x-md" }, [
          _c("div", { staticClass: "col-12 col-md" }, [
            _c("h6", { staticClass: "q-my-sm q-title" }, [
              _vm._v(_vm._s(_vm.$t("delete_team")))
            ]),
            _c("p", {
              staticClass: "q-ma-none text-faded",
              domProps: { innerHTML: _vm._s(_vm.$t("delete_team_hint")) }
            })
          ]),
          _c(
            "div",
            { staticClass: "col-12 col-md-auto" },
            [
              _c(
                "q-btn",
                {
                  staticClass: "q-mt-md",
                  attrs: { color: "red-6", icon: "warning" },
                  on: { click: _vm.handleDeleteTeam }
                },
                [
                  _vm._v(
                    "\n           " +
                      _vm._s(_vm.$t("delete_team")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c("authorization-dialog", { ref: "authorizationDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }